import React, { useState, useEffect } from 'react'
import './HomeNavigation.css'
import HomeHeader from './HomeHeader'
import { FaSyncAlt } from 'react-icons/fa'
//import Footer from '../UIElements/Footer'
import HomeNavLinks from './HomeNavLinks'
import SideDrawer from '../../../admin/components/SideDrawer'
import Backdrop from '../UIElements/Backdrop'
import standingsLogo from '../../../images/standings_transparent.png'

const StatsAndStandingsHomeNavigation = (props) => {
	console.log('inside StatsAndStandingsHomeNavigation: ' + props.leagueId)

	const [drawerIsOpen, setDrawerIsOpen] = useState(false)

	const [isViewingInApp, setIsViewingInApp] = useState(false)

	useEffect(() => {
		const detectApp = () => {
			const hasNativeAppBridge =
				typeof window.makeInAppPurchase === 'function' ||
				typeof window.restorePurchases === 'function' ||
				typeof window.isInCustomTab === 'function'

			setIsViewingInApp(hasNativeAppBridge)
		}

		if (typeof window.executeWhenAppReady === 'function') {
			window.executeWhenAppReady(() => {
				detectApp()
			})
		} else {
			detectApp()
		}
	}, [])

	const openDrawerHandler = () => {
		setDrawerIsOpen(true)
	}

	const closeDrawerHandler = () => {
		setDrawerIsOpen(false)
	}

	const refreshPageHandler = () => {
		window.location.reload()
	}

	return (
		<React.Fragment>
			{drawerIsOpen && <Backdrop onClick={closeDrawerHandler} />}
			<SideDrawer show={drawerIsOpen} onClick={closeDrawerHandler}>
				<nav className='home-navigation__drawer-nav'>
					<HomeNavLinks leagueId={props.leagueId} />
				</nav>
			</SideDrawer>
			<HomeHeader>
				<button
					className='home-navigation__menu-btn'
					onClick={openDrawerHandler}
				>
					<span />
					<span />
					<span />
				</button>
				<div className='headerWidth'>
					<img src={standingsLogo} className='standingsLogo' />
				</div>
				<nav className='home-navigation__header-nav'>
					<HomeNavLinks leagueId={props.leagueId} />
				</nav>
				{isViewingInApp && (
					<button
						type='button'
						className='home-navigation__refresh-btn'
						onClick={refreshPageHandler}
						aria-label='Refresh'
						title='Refresh'
					>
						<FaSyncAlt />
					</button>
				)}
			</HomeHeader>
		</React.Fragment>
	)
}

export default StatsAndStandingsHomeNavigation
